import { gql } from "@apollo/client";

export const SCRATCHPAY_ELIGIBILITY = gql`
  query ScratchPayEligibility {
    scratchpayEligibility {
      eligible
    }
  }
`;

export const SCRATCHPAY_PURCHASE_STATUS = gql`
  query ScratchPayPurchaseStatus($uniqueTransactionId: String!) {
    scratchpayPurchaseStatus(uniqueTransactionId: $uniqueTransactionId) {
      uniqueTransactionId
      status
    }
  }
`;

